import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16064c30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TheTextarea__wrap" }
const _hoisted_2 = { class: "TheTextarea" }
const _hoisted_3 = ["value", "accesskey", "autofocus", "cols", "rows", "maxlength", "disabled", "placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "floating-placeholder"
}
const _hoisted_5 = {
  key: 1,
  class: "TheTextarea__maxlength"
}
const _hoisted_6 = {
  key: 0,
  class: "TheTextarea__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("textarea", {
        ref: "textarea",
        class: _normalizeClass(["TheTextarea", { invalid: _ctx.isInvalid, disabled: _ctx.disabled, autoheight: _ctx.autoheight }]),
        style: _normalizeStyle({ height: _ctx.autoheight ? _ctx.autoheight : 'auto' }),
        value: _ctx.value,
        accesskey: _ctx.accesskey,
        autofocus: _ctx.autofocus,
        cols: _ctx.cols,
        rows: _ctx.rows,
        maxlength: _ctx.maxlength,
        disabled: _ctx.disabled,
        placeholder: _ctx.placeholder,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args)))
      }, null, 46, _hoisted_3),
      (Boolean(_ctx.placeholder))
        ? (_openBlock(), _createElementBlock("label", _hoisted_4, _toDisplayString(_ctx.placeholder), 1))
        : _createCommentVNode("", true),
      (_ctx.maxlength)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getLengthLabel), 1))
        : _createCommentVNode("", true)
    ]),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true)
  ]))
}